import { render } from "./Dashboard.vue?vue&type=template&id=22ba47ca&scoped=true"
import script from "./Dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./Dashboard.vue?vue&type=script&setup=true&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=22ba47ca&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ba47ca"],['__file',"src/views/Dashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22ba47ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22ba47ca', __exports__)) {
    api.reload('22ba47ca', __exports__)
  }
  
  module.hot.accept("./Dashboard.vue?vue&type=template&id=22ba47ca&scoped=true", () => {
    api.rerender('22ba47ca', render)
  })

}


export default __exports__